<template>
    <bc-dialog
        :value="entity_email_dialog"
        :content-class="{ 'd-none': !entity_props_defined }"
        :hide-overlay="!entity_props_defined"
    >
        <v-card>
            <v-card-title>
                <span class="headline">{{ currObjField('entity_emails_id') ? hasScope('update') ? $t('lang.editEmail') : $t('lang.entity_email_details') : $t('lang.addEmail') }}</span>
                <v-spacer></v-spacer>
                <bc-btn-dialog-close
                    @invoke-method="invokeMethod($event)"
                    :dialog-status="entity_email_dialog"
                    action="close"
                ></bc-btn-dialog-close>
            </v-card-title>
            <v-card-text>
                <v-form ref="entity_email">
                    <v-container grid-list-form>
                        <v-layout row wrap>
                            <v-flex xs12 pr-0>
                                <v-layout row>
                                    <v-flex xs6 class="primary-chip-container inner-flex">
                                        <v-chip
                                            v-if="currObjField('prime') == '1'"
                                            color="primary"
                                            class="primary-chip"
                                            disabled
                                        >
                                            {{ $t('lang.primary_caps') }}
                                        </v-chip>
                                        <v-switch
                                            v-else
                                            v-model="entity_email.prime"
                                            :label="$t('lang.primary')"
                                            true-value="1"
                                            false-value="0"
                                        ></v-switch>
                                    </v-flex>
                                    <bc-btn-entity-action
                                        v-if="currObjField('email_link')"
                                        icon="forward_to_inbox"
                                        :text="$t('lang.send_email')"
                                        :currentEntity="current_obj"
                                        :link="current_obj.email_link"
                                    ></bc-btn-entity-action>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="entity_email_dialog"
                                    v-model="entity_email.email_address"
                                    :label="`${$t('lang.email_address')} *`"
                                    :counter="showCounter(entity_email.email_address, 'entity_email.email_address')"
                                    :rules="ifValid('entity_email.email_address')"
									:readonly="!hasScope('update')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="entity_email.email_type"
                                    :label="`${$t('lang.email_type')} *`"
                                    :items="EmailTypes"
                                    :propsMenu="{ top: true }"
                                    :rules="ifValid('entity_email.email_type')"
									:readonly="!hasScope('update')"
                                >
                                    <template slot="item" slot-scope="data">
                                        {{ $t(`lang.${data.item}`) }}
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                        {{ $t(`lang.${data.item}`) }}
                                    </template>
                                </bc-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
                <delete-confirmation-dialog
                    ref="delete_entity_email"
                    :heading="$t('lang.delete_entity_email')"
                    :special="currObjField('notify') == '1' ? $t('lang.delete_email_for_notifications') : ''"
                    :message="$t('lang.confirm_delete_message')"
                    @onConfirm="modifyEntityEmail('delete', currObjField('entity_emails_id'))"
                >
                    <v-form ref="delete_confirm_email" @submit.prevent>
                        <bc-autocomplete
                            v-if="currObjField('prime') == '1' && currObjField('entity_emails_id')"
                            v-model="new_prime_entity_emails_id"
                            :label="`${$t('lang.new_primary_email')} *`"
                            :items="availableItems"
                            item-value="entity_emails_id"
                            item-text="email_address"
                            :rules="ifValid('entity_email.new_prime_entity_emails_id')"
                        ></bc-autocomplete>
                    </v-form>
                </delete-confirmation-dialog>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="hasScope('delete') && currObjField('entity_emails_id') && availableItems.length > 0" color="error" @mouseup.left="$refs.delete_entity_email.openDialog()">{{ $t('lang.delete') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn flat @mouseup.left="close()">{{$t('lang.cancel')}}</v-btn>
                <v-btn
                    v-if="currObjField('entity_emails_id') ? hasScope('update') : hasScope('create')"
                    color="success"
                    @mouseup.left="modifyEntityEmail(currObjField('entity_emails_id') ? 'patch' : 'post', currObjField('entity_emails_id'))"
                >
                    {{$t('lang.save')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </bc-dialog>
</template>
<script>

import { mapState } from "vuex";
import _ from 'lodash'

export default {
    props: {
        getFunction: { // the function used to grab fresh data after email update/delete
            type: Function
        },
        entity_object: { // object name matching first portion of api url i.e. people | me | customers
            type: String,
            required: true
        },
        entity_id: { // if object is not 'me', use id in urlObject
            type: [String, Number]
        },
        total_items: { // to decide if a new email needs to be prime
            type: [Array, Object]
        },
        scope: { // scope from parent
            type: [String],
            default: null
        }
    },
    data() {
        return {
            entity_email: {
                prime: "",
                email_address: "",
                email_type: ""
            },
            current_obj: null,
            entity_email_dialog: false,
            EmailTypes: ["home", "work", "other"],
            new_prime_entity_emails_id: null
        }
    },
    computed: {
        ...mapState({
            rules_entity_email: state => state.validation.rules_entity_email
        }),
        entity_props_defined(){ // require both entity_object and entity_id unless entity_object is 'me' then entity_id is not required
            return (typeof(this.entity_object) !== 'undefined' && (this.entity_object == 'me' || typeof(this.entity_id) !== 'undefined'));
        },
        fetchObject(){ // use entity_object to create store action
            if(!this.entity_props_defined){
                return "";
            }else{
                return `fetch${_.upperFirst(_.camelCase(this.entity_object))}`;
            }
        },
        urlObject(){ // use entity_object and entity_id to create url portion of store dispatch
            if(!this.entity_props_defined){
                return "";
            }else{
                return '/' + this.entity_object + (this.entity_object != 'me' ? '/' + this.entity_id : "") + '/emails';
            }
        },
        currObjField(){
            return field => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : ''
            }
        },
        availableItems(){
            let items = [];
            if(this.total_items && this.total_items.length > 1){
                return this.total_items.filter(item => item.entity_emails_id != this.currObjField('entity_emails_id'));
            }
             return items;
        },
        hasScope(){
            return scope => {
                return !this.scope || this.scope.includes(`${scope}`) || !this.currObjField('entity_emails_id');
            }
        }
    },
    mounted: function() {
        // manually throw vue warning since dynamically setting entity_id as 'required: true/false' is not possible
        if(typeof(this.entity_id) == 'undefined' && typeof(this.entity_object) !== 'undefined' && this.entity_object != 'me'){
            throw new Error('Missing required prop: "entity_id"');
        }
    },
    methods: {
        close() {
            this.new_prime_entity_emails_id = null;
            this.entity_email_dialog = false;
            this.$refs.delete_entity_email.close();
            this.$store.commit('validationOff');
            this.$store.commit('toggleModalLoader', false);
        },
        modifyEntityEmail(method = null, id = null) {
            if(method){
                this.$store.commit('validationOn');
                this.$nextTick(() => {
                    if( (method == 'delete' && this.validateForm('delete_confirm_email')) || (method != 'delete' && this.validateForm('entity_email')) ) {
                        this.$store.commit('toggleModalLoader', true);
                        this.$store.dispatch(
                            this.fetchObject,
                            {
                                pk: 'entity_emails_id',
                                id: id,
                                url: `${this.urlObject}/${id ? id : ''}${method == 'delete' && id && this.currObjField('prime') == '1' ? '/' + this.new_prime_entity_emails_id : ''}`,
                                method: method,
                                stateProperty: 'entity_emails',
                                commit: true,
                                body: this.entity_email
                            }
                        ).then((data) => {
                            if(data && data.code == '200'){
                                this.close();
                            }else{
                                this.$store.commit('toggleModalLoader', false);
                            }
                        })
                    }
                });
            }
        },
        showEmail(item = null){
            this.current_obj = item;

            if(this.$refs.entity_email) item ? this.$refs.entity_email.resetValidation() : this.$refs.entity_email.reset();

            this.$nextTick(() => {
                this.assignObj(this.entity_email, item, this.rules_entity_email)
                // if there are existing emails, allow new emails to be made prime, else set to prime
                if(!item){
                    this.current_obj = {};
                    this.current_obj.prime = (this.total_items || []).length < 1 ? '1' : '0';
                    this.entity_email.prime = this.current_obj.prime;
                }
                this.entity_email_dialog = true;
            })
        },
    }
};
</script>